import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { DictionaryClientDataRequestType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';
import { FilesHandler } from '../../utils/files-handler';
import { DateInputFillMode, DateInputRounded, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { isNotEmpty } from 'src/app/extensions/utilities';
import { SIGNAL_ITEM_KEY } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'app-add-personal-information-request',
  templateUrl: './add-personal-information-request.component.html',
  styleUrls: ['./add-personal-information-request.component.scss'],
  standalone: false,
})
export class AddPersonalInformationRequestComponent implements OnInit {
  @ViewChild('form') public form: NgForm;

  clientDataRequestSaveModel: app.models.ClientDataRequestSaveModel = {
    documentsAttached: [],
  } as app.models.ClientDataRequestSaveModel;

  maritalStatuses: app.models.DictionaryDataModel[] = {} as app.models.DictionaryDataModel[];
  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public size: DateInputSize = 'large';

  isPJ: boolean;
  isDataLoaded = false;

  private stateSignalItem: any;

  constructor(
    private _globalService: GlobalService,
    private _router: Router,
    private _dictionaryService: DictionaryAPIService,
    private _partnerService: PartnerAPIService,
    public _filesHandler: FilesHandler,
    public _activatedRoute: ActivatedRoute
  ) {
    this.stateSignalItem = this._globalService.getSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA);

    if (isNotEmpty(this.stateSignalItem)) {
      this.clientDataRequestSaveModel = this.stateSignalItem.data as app.models.ClientDataRequestSaveModel;
      this.isPJ = this.stateSignalItem.extras?.isPJ;
      this.isDataLoaded = this.stateSignalItem.extras?.isDataLoaded;
    }
  }

  ngOnInit(): void {
    if (!isNotEmpty(this.stateSignalItem)) {
      this.loadData();
    }
  }

  loadData() {
    let source = forkJoin([
      this._partnerService.getCompanyInfo(),
      this._dictionaryService.getMaritalStatuses(),
      this._dictionaryService.getClientDataRequestTypes(),
    ]);
    source.subscribe(([partnerInfoResult, dictionaryMaritalStatuses, dictionaryClientDataRequestTypes]) => {
      let partnerInfo = partnerInfoResult.data;
      if (partnerInfo) {
        this.isPJ = partnerInfo.isPJ;
        this.clientDataRequestSaveModel.partnerExternalEntityId = partnerInfo.partnerExternalEntityId;

        if (this.isPJ) {
          this.clientDataRequestSaveModel.companyInformation = {
            legalForm: partnerInfo.legalForm,
            mainActivityField: partnerInfo.mainActivityField,
            name: partnerInfo.companyName,
            registrationCode: partnerInfo.registrationCode,
          } as app.models.ClientDataRequestsCompanyInformationModel;
        } else {
          this.clientDataRequestSaveModel.personalInformation = {
            idSeries: partnerInfo.idSeries,
            idNumber: partnerInfo.idNumber,
            issuedBy: partnerInfo.issuedBy,
            expiryDate: partnerInfo.expiryDate,
            firstName: partnerInfo.personFirstName,
            lastName: partnerInfo.personLastName,
            dictionaryPersonMaritalStatusId: undefined,
            personExternalEntityId: partnerInfo.personExternalEntityId,
          } as app.models.ClientDataRequestsPersonalInformationModel;
        }

        if (dictionaryClientDataRequestTypes.data) {
          let addressRequestType = dictionaryClientDataRequestTypes.data.find(
            x =>
              x.code ==
              (this.isPJ
                ? DictionaryClientDataRequestType.CompanyInformation
                : DictionaryClientDataRequestType.PersonalInformation)
          );
          if (addressRequestType) {
            this.clientDataRequestSaveModel.dictionaryClientDataRequestTypeId = addressRequestType.id;
            this.clientDataRequestSaveModel.description = addressRequestType.description;
          }
        }
      }

      this.isDataLoaded = true;
      this.maritalStatuses = dictionaryMaritalStatuses.data;
    });
  }

  sendRequestCofirmationHandler() {
    if (this.form.invalid) {
      return;
    }

    this.stateSignalItem = {
      data: this.clientDataRequestSaveModel,
      extras: {
        isPJ: this.isPJ,
        isDataLoaded: this.isDataLoaded,
      },
      routePath: this._activatedRoute.snapshot.routeConfig.path,
    };
    this._globalService.setSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA, this.stateSignalItem);
    this._router.navigate(['requests/client-data/new/request-preview']);
  }

  redirectFieldSelectionHandler() {
    this._router.navigate(['requests/client-data/new']);
  }

  redirectListHandler = () => {
    this._router.navigate(['requests/client-data']);
  };
}
